import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Ec_member } from '../models/ec/ec_member';

@Injectable({
  providedIn: 'root'
})
export class EcPersonSearchService {

  constructor(private http: HttpClient) { }

  getById(search_id_term: string): Promise<Ec_member> {
    return new Promise((resolve, reject) => {
      return this.http.get('https://licence.equestrian.ca/resultsws/wcf/ResultsWCF.svc/GetECRiderBySLN_v2?sln=' + search_id_term + '&compId=1111&password=barn').subscribe((response: any) => {
        resolve(response);
      },
        error_response => {
          if (error_response instanceof HttpErrorResponse) {
            reject(error_response.error);
          }
          reject(error_response);
        });
    });
  }

  getByLastName(search_name_term: string): Promise<Ec_member[]> {
    return new Promise((resolve, reject) => {
      return this.http.get('https://licence.equestrian.ca/resultsws/wcf/ResultsWCF.svc/GetECRiders_ByLastName_v2?lastname=' + encodeURIComponent(search_name_term) + '&compId=1111&password=barn').subscribe((response: any) => {
        resolve(response);
      },
        error_response => {
          if (error_response instanceof HttpErrorResponse) {
            reject(error_response.error);
          }
          reject(error_response);
        });
    });
  }

}
